import React, {Component} from 'react';
import Header from './../components/Header'
import Footer from './../components/Footer'
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {loadCategories} from "../actionCreators";

class NotFoundShop extends Component {

  handleGoShop = () => {
    const {shops, urlHashIndex, history} = this.props;
    let firstShop = shops[0].url_hash;
    let shopAddress = shops[0].address;
    loadCategories(firstShop, shopAddress);
    // history.push(`/shop/${firstShop}`);
    window.location.href = `/shop/${firstShop}`;
  }

  render() {
    return (
      <div className="body">
        <Header selectShop={false} url_hash={'not-found-shop'} isShowAddress={true}/>
        <main>
          <h1 className="not-found">Not found shop</h1>
          <div className="not-found__return-wrap">
            <a onClick={this.handleGoShop} className="not-found__return">Kehre zum Shop zurück</a>
          </div>
        </main>
        <Footer/>
      </div>
    )
  }
}

export default withRouter(connect((state) => {
  return {
    shops: state.shops.shopList,
    urlHashIndex: state.shops.urlHashIndex
  }
}, {loadCategories})(NotFoundShop));



// WEBPACK FOOTER //
// ./src/routers/NotFoundShop.js